const MISSIONS_FETCHED = 'redux/missions/MISSIONS_FETCHED';

export default {
  MISSIONS_FETCHED,
};
